import { StateToken } from '@ngxs/store';

import { RuleType, SupportedCriteria } from '@app/criterion-addition/shared/models/rule.models';

export interface CriterionAdditionStateModel {
  ruleTypes: null | RuleType[];
  supportedCriteria: null | SupportedCriteria[];
}

export const CRITERION_ADDITION_STATE = new StateToken<CriterionAdditionStateModel>('criterionAddition');
